export default __webpack_public_path__ + "static/media/Group9198.86cc8bde.svg";